import {gh} from "../../general/general-helpers";

(function( $ ) {
	if ( typeof ye404LoadedPosts === 'undefined' ) {
		return false;
	}

	/* Load More functionality
    -------------------------------------------------------------------*/
	const loadMoreBtn = document.getElementById( 'load-more-btn' );

	loadMoreBtn.addEventListener( 'click', function() {

		gh.simpleLoadMoreContent(
			{
				action:       'p404_load_more_content',
				loaded_posts: ye404LoadedPosts, // set in page-home-new.php
			},
			this,
			() => {
				document.getElementById( 'ajax-loaded-content' ).querySelectorAll( '.--no-delim' ).forEach( (elem) => {
					elem.classList.remove( '--no-delim' );
				} );
			},
		);
	} ); // CLICK


})( jQuery );